import { render, staticRenderFns } from "./about.vue?vue&type=template&id=25f12532&"
import script from "./about.js?vue&type=script&lang=js&"
export * from "./about.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports